import * as React from 'react';
import { useRouteData } from 'react-static';
import { useDebug } from '../../common/hooks/useDebug';
import { useWindowResize } from '../../common/hooks/useWindowResize';
import { useTranslations } from '../../common/translation';
import { FeaturedBlogs } from '../../components/featured-blogs/FeaturedBlogs';
import { HeadTitle } from '../../components/head-title/HeadTitle';
import { RowHeader } from '../../components/row-header/RowHeader';
import { DefaultLayout } from '../default/DefaultLayout';
import { ArticleResults } from './article-results/ArticleResults';
import { ArticlesLayoutProps } from './ArticlesLayout.props';
import { StyledArticlesLayout } from './ArticlesLayout.styles';
import translations from './translations';

// noinspection JSUnusedGlobalSymbols
export default () => {
  const { featuredBlogsProps, locale, translatedPaths } = useRouteData<ArticlesLayoutProps>();
  const { t } = useTranslations(translations, locale);
  const { isSmallScreen } = useWindowResize();
  const seo = {
    description: '',
  };
  const blogCount = isSmallScreen ? 3 : 5;
  const hiddenResults = featuredBlogsProps
    ? (featuredBlogsProps.blogs || []).slice(0, blogCount).map((blog) => blog.id)
    : [];

  useDebug('app:layout:ArticlesLayout', { props: { featuredBlogsProps, locale, translatedPaths } });

  return (
    <DefaultLayout locale={locale} seo={seo} translatedPaths={translatedPaths}>
      <HeadTitle title={t('pageTitle', 'News Articles')} />
      <StyledArticlesLayout>
        <FeaturedBlogs {...featuredBlogsProps} showButton={false} showTitle={false} />
        <RowHeader headingTag='h1' title={t('sectionTitle', 'News Articles')} />
        <ArticleResults key={locale} hiddenResults={hiddenResults} query='f[0]=type:article&qt=%20' />
      </StyledArticlesLayout>
    </DefaultLayout>
  );
};
